import React from 'react'
import MapImg from '../assets/img/world-map.svg'

const ContactPage = () => {
  return (
    <div id='contact_page'>
        <div className='page-header'>
            <span>CONTACT US</span>
            <h1>We'd love to hear from you</h1>
            <p>We have a friendly team ready to speak with you.</p>
        </div>
        <div className='img-container'>
            <img src={MapImg} alt='World Map Pattern' />
        </div>
        <div className='contact-details'>
            <div className='row gx-5 gy-5'>
                <div className="col-sm-4">
                    <h4>Support</h4>
                    <p>Our friendly team is here to help</p>
                    <a href="mailto:infojnb@twf.co.za">infojnb@twf.co.za</a>
                </div>
                <div className="col-sm-4">
                    <h4>Sales</h4>
                    <p>Question or queries? Get in touch!</p>
                    <a href="mailto:infojnb@twf.co.za">infojnb@twf.co.za</a>
                </div>
                <div className="col-sm-4">
                    <h4>Phone</h4>
                    <p>Mon-Fri from 08:00-16:30</p>
                    <a href="tel:+27112532600">+27112532600</a>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ContactPage